<template>
    <div class="wrapper">
        <div class="page page1">
            <h4 class="w3-center">{{ headerText }}</h4>
            <table class="header-table">
                <tr class="header-row-1">
                    <td class="header-col-1">
                        გაცემის თარიღი/<br>Report Date:
                    </td>
                    <td class="header-col-2">
                        {{testData.reportDate}}
                    </td>
                    <td class="header-col-3">
                        პაციენტის სახელი, გვარი/<br>Patient Full Name
                    </td>
                    <td colspan="2">
                        {{testData.patient.name}}
                    </td>
                </tr>
                <tr class="header-row-2">
                    <td rowspan="2">
                        დრო/Time
                    </td>
                    <td rowspan="2">
                        {{testData.reportTime}}
                    </td>
                    <td>
                        <div class="sex-width">
                            სქესი/Sex:
                        </div>
                        <div class="sex-width-rest">
                            <span class="w3-padding-small">{{testData.patient.sex === 'male' ? '&#9745;' : '&#9744;'}} მამ./male</span><br>
                            <span class="w3-padding-small">{{testData.patient.sex === 'female' ? '&#9745;' : '&#9744;'}} მდ./female</span>
                        </div>
                    </td>
                    <td class="header-col-4">
                        დაბადების თარიღი/<br>Date Of Birth:
                    </td>
                    <td class="header-col-5">
                        {{testData.patient.dateOfBirth}}
                    </td>
                </tr>
                <tr class="header-row-3">
                    <td>
                        ტელ/TEL: {{testData.patient.tel}}
                    </td>
                    <td>
                        ელ. ფოსტა/Email:
                    </td>
                    <td>
                        {{testData.patient.email}}
                    </td>
                </tr>
            </table>
            <div class="full-width heading-wrapper">
                <div class="r-placeholder">
                </div>
                <div ც>
                    <h4 class="heading">
                        ლაბორატორიული კვლევის შედეგი<br>
                        Laboratory Test Result 
                    </h4>
                </div>
                <div class="r-placeholder">
                    <p class="test-res-num">№ {{testData.laboratoryTestResultNumber}}</p>
                </div>
            </div>
            <div class="sample-id-wrapper">
                <div class="sample-id-l"></div>
                <div class="sample-id-text">
                    ნიმუშის საიდენტიფიკაციო ნომერი / Sample ID:
                </div>
                <div class="sample-id-r">
                    <span class="outline-box id-box">{{ testData.sampleId }}</span>
                </div>
            </div>
            <p>
                სამეცნიერო პროექტი / Scientific Project: <span class="">{{ testData.scientificProject }}</span>
            </p>
            <table class="sample-table">
                <tr>
                    <td class="sample-col-1">
                        ნიმუშის აღების თარიღი<br>Date of sampling:
                    </td>
                    <td class="sample-col-2">
                        {{testData.sample.dateOfSampling}}
                    </td>
                    <td class="sample-col-3 no-border"></td>
                    <td class="sample-col-4">
                        ნიმუშის მიღების თარიღი<br>Date of sample receiving:
                    </td>
                    <td class="sample-col-5">
                        {{testData.sample.dateOfSampleReceiving}}
                    </td>
                </tr>
                <tr>
                    <td>
                        დრო/Time
                    </td>
                    <td>
                        {{testData.sample.dateOfSamplingTime}}
                    </td>
                    <td class="no-border"></td>
                    <td>
                        დრო/Time
                    </td>
                    <td>
                        {{testData.sample.dateOfSampleReceivingTime}}
                    </td>
                </tr>
            </table>
            <table class="ncdc-table">
                <tr>
                    <td class="ncdc-col-1">
                        დკსჯეც-ის კვლევის შედეგის მიმღები ეპიდემიოლოგი:<br> NCDC’s Epidemiologist receiving laboratory test results:
                    </td>
                    <td class="ncdc-col-2 ">
                        {{testData.ncdcEpidName}}
                    </td>
                </tr>
            </table>
            <table class="sample-type-table">
                <tr>
                    <td rowspan="3" class="sample-type-col-1">
                        ნიმუშის ტიპი<br>Sample type:
                    </td>
                    <td rowspan="3" class="sample-type-col-2">
                        {{testData.sample.type}}
                    </td>
                    <td  class="sample-type-col-3">
                        გამოსაკვლევი ნიმუშის მდგომარეობა / Sample conditions:
                    </td>
                </tr>
                <tr>
                    <td>
                        {{testData.sample.cond === 'satisfying' ? '&#9745;' : '&#9744;'}} დამაკმაყოფილებელი/Satisfying
                    </td>
                </tr>
                <tr>
                    <td>
                        {{testData.sample.cond !== 'satisfying' ? '&#9745;' : '&#9744;'}} არადამაკმაყოფილებელი/Not satisfying
                    </td>
                </tr>
            </table>
            <div class="quality-note-div">
                <label class="quality-note-label">
                    შენიშვნა ნიმუშის ხარისხის შესახებ / Quality Note:
                </label>
                <p class="quality-note padding-5">
                    {{testData.sample.note}}
                </p>
            </div>
            <table class="req-table">
                <tr>
                    <td class="req-col-1">
                        დამკვეთის სახელი, გვარი<br>Requester name:
                    </td>
                    <td class="req-col-2">
                        {{testData.requestor.name}}
                    </td>
                    <td class="req-col-3">
                        ტელ/Tel:
                    </td>
                    <td class="req-col-4">
                        {{testData.requestor.tel}}
                    </td>
                </tr>
                <tr>
                    <td>
                        დაწესებულება Institution:
                    </td>
                    <td colspan="3">
                        {{testData.requestor.institution}}
                    </td>
                </tr>
                <tr>
                    <td>
                        განყოფილება<br>Unit:
                    </td>
                    <td>
                        {{testData.requestor.unit}}
                    </td>
                    <td>
                        ელ. ფოსტა<br>E-mail:
                    </td>
                    <td>
                        {{testData.requestor.email}}
                    </td>
                </tr>
                <tr>
                    <td>
                        მისამართი<br>Address:
                    </td>
                    <td colspan="3">
                        {{testData.requestor.address}}
                    </td>
                </tr>
                <tr>
                    <td>
                        მოთხოვნილი გამოკვლევა<br> Requested examination:
                    </td>
                    <td colspan="3">
                        {{testData.requestor.requestedExamination}}
                    </td>
                </tr>
            </table>
            <div class="footer-div">
                <p class="footer-par">
                    დაავადებათა კონტროლის ეროვნული ცენტრი – მოლეკუკური დიაგნოსტიკის ცენტრი<br>National Center for Disease Control – Center of Molecular Diagnostics Laboratory<br>ლუბლიანას #11ა, ტელ: (+995 32)  236 95 20
                </p>
            </div>
        </div>
        <div class="page page2">
            <h4 class="w3-center">{{ headerText }}</h4>
            <table class="header-table">
                <tr class="header-row-1">
                    <td class="header-col-1">
                        გაცემის თარიღი/<br>Report Date:
                    </td>
                    <td class="header-col-2">
                        {{testData.reportDate}}
                    </td>
                    <td class="header-col-3">
                        პაციენტის სახელი, გვარი/<br>Patient Full Name
                    </td>
                    <td colspan="2">
                        {{testData.patient.name}}
                    </td>
                </tr>
                <tr class="header-row-2">
                    <td rowspan="2">
                        დრო/Time
                    </td>
                    <td rowspan="2">
                        {{testData.reportTime}}
                    </td>
                    <td>
                        <div class="sex-width">
                            სქესი/Sex:
                        </div>
                        <div class="sex-width-rest">
                            <span class="w3-padding-small">{{testData.patient.sex === 'male' ? '&#9745;' : '&#9744;'}} მამ./male</span><br>
                            <span class="w3-padding-small">{{testData.patient.sex === 'female' ? '&#9745;' : '&#9744;'}} მდ./female</span>
                        </div>
                    </td>
                    <td class="header-col-4">
                        დაბადების თარიღი/<br>Date Of Birth:
                    </td>
                    <td class="header-col-5">
                        {{testData.patient.dateOfBirth}}
                    </td>
                </tr>
                <tr class="header-row-3">
                    <td>
                        ტელ/TEL: {{testData.patient.tel}}
                    </td>
                    <td>
                        ელ. ფოსტა/Email:
                    </td>
                    <td>
                        {{testData.patient.email}}
                    </td>
                </tr>
            </table>
            <div class="result-div">
                <label class="result-label">
                    PCR კვლევის შედეგი / PCR  Test Results:
                </label>
                <p class="result-body padding-5">
                    {{testData.testResult === 'Positive(+)' ? 'ახალი კორონავირუსის (nCoV) პჯრ რეალურ დროში:    დადებითი SARS-CoV-2-ზე / Positive on SARS-CoV-2' : 'ახალი კორონავირუსის (nCoV) პჯრ რეალურ დროში:    უარყოფითი SARS-CoV-2-ზე / Negative on SARS-CoV-2'}}
                </p>
            </div>
            <div class="note-div">
                <label class="note-label">
                    შედეგების ინტერპრეტაცია /კომენტარები / Results interpretation / Comments :
                </label>
                <p class="note-body padding-5">
                    შენიშვნა /Note:  უარყოფითი პასუხი ყოველთვის არ ნიშნავს ჭეშმარიტად უარყოფითს, რადგან დამოკიდებულია ნაცხში ვირუსის მოხვედრის ალბათობაზე/ Negative results does not always mean truly negative, as it depends on the likelihood of virus to get into the smear
                </p>
            </div>
            <p>
                კვლევა შეასრულა  / Test Performed by: <img class="signiture" src="../assets/sign/ზანდა.png">
            </p>
            <p>
                გადაამოწმა / Reviewed by: <img class="signiture" src="../assets/sign/მაია.png">
            </p>
            <p>
                <img class="stamp" src="../assets/sign/stamp.png">
            </p>
            <div class="footer-div">
                <p class="footer-par">
                    დაავადებათა კონტროლის ეროვნული ცენტრი – მოლეკუკური დიაგნოსტიკის ცენტრი<br>National Center for Disease Control – Center of Molecular Diagnostics Laboratory<br>ლუბლიანას #11ა, ტელ: (+995 32)  236 95 20
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

var api_path = "/php_scripts/";
if (process.env.NODE_ENV === "development") {
  api_path = "http://localhost/php_scripts/";
}
export default {
    props: ['testId'],
    data: () => {
        return {
            headerText: 'მოლეკულური დიაგნოსტიკის ცენტრი',
            testData: {
                reportDate: null,
                reportTime: null,
                patient: {
                    name: null,
                    sex: null,
                    dateOfBirth: null,
                    tel: null,
                    email: null,
                },
                laboratoryTestResultNumber: 1234,
                sampleId: '01909381',
                scientificProject: '332ffg42',
                ncdcEpidName: null,
                sample: {
                    dateOfSampling: null,
                    dateOfSamplingTime: null,
                    dateOfSampleReceiving: null,
                    dateOfSampleReceivingTime: null,
                    type: null,
                    cond: null,
                    note: 'null',
                },
                requestor: {
                    name: null,
                    tel: null,
                    institution: null,
                    unit: null,
                    email: null,
                    address: null,
                    requestedExamination: null,
                },
                testResult: null,
            }
        }
    },
    created() {
        axios
        .get(api_path + 'get_covit_test_by_test_id.php', {
          params: {
            test_id: this.testId
          }
        })
        .then((response) => {
          this.testData = JSON.parse(response.data.covid_data)
          console.log(this.testData);
          setTimeout(() => {
              window.print();
          }, 1000)
        })
        .catch((error) => {
          console.log(error)
        })
    }
}
</script>

<style>
table {
    border-collapse: collapse;
}
th, td {
  border: 1px solid black;
  padding: 2px;
}
.outline-box {
    border: 1px solid;
    padding: 3px 10px;
}
.padding-5 {
    padding: 5px;
}
.no-border {
    border: none;
}
.wrapper {
    position: relative;
}
.full-width {
    width: 100%;
}
.heading-wrapper {
    display: flex;
}
.heading {
    flex: 1;
    text-align: center;
}
.r-placeholder {
    flex: 1;
}
.r-placeholder {
    flex: 1;
}
.test-res-num {
    padding: 3px 9px;
    margin-top: 20px;
    margin-left: 20px;
    border: 1px solid;
    width: 70%;
}
.page {
    position: relative;
    width: 800px;
    height: 1140px;
}
.page1 {
    background-color: aqua;
    margin-bottom: 30px;
}
.page2 {
    background-color: bisque;
}
.hideNavBar {
    display: none;
}
/* header table */
.header-table {
    width: 100%;
    font-size: 10pt;
    margin-top: 20px;
    margin-bottom: 20px;
    border-style: solid;
    border-width: 1px;
}
.header-col-1 {
    width: 16%;
}
.header-col-2 {
    width: 16%;
}
.header-col-3 {
    width: 24%;
}
.header-col-4 {
    width: 20%;
}
.header-col-5 {
    width: 24%;
}
.header-row-1 {
    line-height: 20px;
}
.header-row-2 {
    line-height: 20px;
}
.header-row-3 {
    line-height: 25px;
}
/* sample table css */
.sample-table {
    margin-top: 20px;
    width: 100%;
}
.sample-col-1 {
    width: 25%;
}
.sample-col-2 {
    width: 16%;
}
.sample-col-3 {
    width: 18%;
}
.sample-col-4 {
    width: 25%;
}
.sample-col-5 {
    width: 16%;
}
/* ncdc table */
.ncdc-table {
    margin-top: 20px;
    width: 100%
}
.ncdc-col-1 {
    width: 50%;
}
.ncdc-col-2 {
    width: 50%;
}
/* sample type table */
.sample-type-table {
    margin-top: 20px;
    width: 100%;
}
.sample-type-col-1 {
    width: 20%;
}
.sample-type-col-2 {
    width: 30%;
}
.sample-type-col-3 {
    width: 50%;
}
/* quality note */
.quality-note-div {
    margin-top: 26px;
}
.quality-note-label {
    margin-left: 16px;
}
.quality-note {
    margin-top: 5px;
    height: 60px;
    border-style: solid;
    border-width: 1px;
}
/* requester data */
.req-table {
    width: 100%;
}
.req-col-1 {
    width: 30%;
}
.req-col-2 {
    width: 30%;
}
.req-col-3 {
    width: 12%;
}
.req-col-4 {
    width: 28%;
}
/* footer */
.footer-div {
    margin-bottom: -10px;
    font-size: 9pt;
    position: absolute;
    bottom: 0;
    width: 100%;    
}
.footer-par {
    text-align: center;
}
/* result */
.result-div {
    font-weight: 600;
    letter-spacing: 0.2pt;
    margin-top: 40px;
}
.result-label {
    margin-left: 16px;
}
.result-body {
    margin-top: 5px;
    border: 1px solid;
}
/* note */
.note-div {
    margin-top: 40px;
}
.note-label {
    margin-left: 16px;
}
.note-body {
    margin-top: 5px;
    border: 1px solid;
}
.sex-width {
    width: 38%;
    display: inline-block;
}
.sex-width-rest {
    display: inline-block;
    width: 62%;
}
img.signiture {
    width: 100pt;
    height: auto;
}
img.stamp {
    margin-left: 560px;
    margin-top: -150px;
    width: 130pt;
    height: auto;
}
.line-high {
    height: 100px;
    width: 70%;
}
.text-transparant {
    opacity: 0;
}
.sample-id-wrapper {
    margin-top: 0;
    display: flex;
}
.sample-id-text {
    flex: 2;
}
.sample-id-l {
    flex: 1;
}
.sample-id-r {
    flex: 1;
}
.id-box {
    width: 60px;
}
</style>
